



























import { Component, Vue } from "vue-property-decorator";
import { deletePowerPlan } from "@/services/powerPlans/powerPlanService";

@Component
export default class PowerPlanDeleteModal extends Vue {
    powerPlanToBeDeleted: string = "";
    powerPlanName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(powerPlanId: string, name: string) {
        this.powerPlanToBeDeleted = powerPlanId;
        this.powerPlanName = name;
        this.$bvModal.show("modal-deletePowerPlan");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deletePowerPlan");
        this.powerPlanName = "";
        this.powerPlanToBeDeleted = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deletePowerPlan(this.powerPlanToBeDeleted).then(() => {
            this.$emit("reload");
            this.powerPlanName = "";
            this.powerPlanToBeDeleted = "";
            this.$bvModal.hide("modal-deletePowerPlan");
        });
    }
}
